export default __webpack_public_path__ + "static/media/contactsMap.7c955d34.png";